__turbopack_context__.v({
  "hasInsets": "AppWrapper-module-sass-module__tZgsla__hasInsets",
  "inner": "AppWrapper-module-sass-module__tZgsla__inner",
  "main": "AppWrapper-module-sass-module__tZgsla__main",
  "wrapper": "AppWrapper-module-sass-module__tZgsla__wrapper",
});
